import type { ReactElement } from 'react'
import { SearchIcon } from './icons'
import styles from './EmptyState.module.css'

/**
 * Props for {@link EmptyState}.
 */
export interface EmptyStateProps {
  /** Title line ("No stations found"). */
  readonly title: string
  /** Subtitle line ("Try a different name or check the spelling."). */
  readonly subtitle: string
}

/**
 * The `empty`-state body — a centred magnifying-glass illustration plus
 * a title and subtitle. No retry affordance (spec §4 — the `error`
 * state was removed).
 *
 * Figma node 6175:15850 (EmptyState). Carries the spec a11y id
 * `suggester-empty`.
 */
export function EmptyState({ title, subtitle }: EmptyStateProps): ReactElement {
  return (
    <div className={styles.empty} data-testid="suggester-empty">
      <span className={styles.glyph} aria-hidden>
        <SearchIcon size={56} />
      </span>
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  )
}
